import { APICallV3Post } from 'reactApp/api/APICall';

export class PdfAttachViewPartAPICall extends APICallV3Post {
    _method = '/ovidius/pdf/file/view_part';
    _responseType = 'arraybuffer' as const;
    _withCredentials = true;
    _headers = { 'Content-Type': 'application/octet-stream' };
}
